import { Box, SpaceBetween } from '@cloudscape-design/components';
import { ConfigurationObject } from '../../services/configs-api';

interface HolidayDetailProps {
  config: ConfigurationObject;
}

/**
 * Human-readable detail view for Holiday/Closure config type.
 * Shows: Start/End dates, Closure Message, Action on holiday
 */
export function HolidayDetail({ config }: HolidayDetailProps) {
  const payload = config.payload ?? {};

  const startDate = (payload.startDate as string) ?? '';
  const endDate = (payload.endDate as string) ?? '';
  const message = (payload.message as string) ?? '—';
  const action = (payload.action as string) ?? '—';

  // Format action to plain English
  const actionLabels: Record<string, string> = {
    resume: 'Continue the call as normal',
    disconnect: 'End the call',
    transfer: 'Transfer to external number',
  };
  const actionDisplay = actionLabels[action] ?? action;

  return (
    <SpaceBetween size="m">
      <div>
        <Box variant="awsui-key-label">Period</Box>
        <div>
          {startDate && endDate
            ? `${startDate} to ${endDate}`
            : startDate || endDate || '—'}
        </div>
      </div>

      <div>
        <Box variant="awsui-key-label">Closure Message</Box>
        <Box variant="p" color="text-body-secondary">
          "{message}"
        </Box>
      </div>

      <div>
        <Box variant="awsui-key-label">Action on Holiday</Box>
        <div>{actionDisplay}</div>
      </div>
    </SpaceBetween>
  );
}
